<template>
    <app-layout title="Beheer">
        <template #header>
            <page-title title="Beheer" />
        </template>

        <template #pageContent>
            <ul>
                <li>
                    <Link :href="route('configuration.request_duedates')">
                        Duedates
                    </Link>
                </li>
<!--                <li>-->
<!--                    <Link :href="route('configuration.overdue_reasons')">-->
<!--                        Redenen overdue-->
<!--                    </Link>-->
<!--                </li>-->
                <li>
                    <Link :href="route('configuration.post_invoice_reasons')">
                        Redenen nafacturatie
                    </Link>
                </li>
                <li>
                    <Link :href="route('configuration.assignment_types')">
                        Type opdrachten
                    </Link>
                </li>
                <li>
                    <Link :href="route('configuration.webshop-products')">
                        Webshop producten
                    </Link>
                </li>
                <li v-if="this.$page.props.user.roles.includes('admin')">
                    <Link :href="route('configuration.failed-webshop-orders')">
                        Gefaalde webshop orders
                    </Link>
                </li>
                <li v-if="this.$page.props.user.roles.includes('admin')">
                    <Link :href="route('configuration.webhooks-webshops')">
                        Status webhooks webshops
                    </Link>
                </li>
            </ul>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'

import { Link } from '@inertiajs/inertia-vue3';

export default {
    components: {
        AppLayout,
        PageTitle,
        Link
    },
}

</script>
